/**
 * 分岐の選択肢（別の動画へ進むボタン）を出し始めるタイミング（BOX・WIDE 共通）。
 *
 * 選択肢は必ず動画の「再生中」に出し始め、終了後も残す。動画が終わってから初めて出す
 * 独立した画面で別の動画へ進ませる形は作らない（ADR-0023 A-1）。
 * 視聴者が再生中に実際に見て押せる長さが要るので、1秒などに縮めない。
 */
export const BRANCH_CHOICE_LEAD_SEC = 3

/**
 * 再生位置が「動画終了の BRANCH_CHOICE_LEAD_SEC 秒前」以降に入ったか。
 * 動画長が未確定（0・NaN）のあいだは false。尺が短い動画は冒頭から true になる。
 */
export function isWithinEndLead(currentTime: number, duration: number | null | undefined): boolean {
  if (duration == null || !Number.isFinite(duration) || duration <= 0) return false
  return currentTime >= duration - BRANCH_CHOICE_LEAD_SEC
}

/**
 * 「指定時刻」が遅すぎて、動画終了の BRANCH_CHOICE_LEAD_SEC 秒前より後になっているか。
 * 動画より長い時刻（30秒の動画に 0:45 など）や、終了1秒前などを指す。
 * 動画の差し替えで尺が短くなった場合や、入力制限より前に保存された値でも起こるため、
 * 再生側ではこのとき「末尾」と同じ扱い（終了3秒前から出して終了後も残す）にする。
 * 動画長が未確定（0・NaN）のあいだは false。
 */
export function isCueTooLate(cueTime: number, duration: number | null | undefined): boolean {
  if (duration == null || !Number.isFinite(duration) || duration <= 0) return false
  return cueTime > duration - BRANCH_CHOICE_LEAD_SEC
}

/**
 * 編集画面で「指定時刻」に入れられる最も遅い時刻（秒）。動画長が不明なら null（制限しない）。
 */
export function latestBranchCueTime(duration: number | null | undefined): number | null {
  if (duration == null || !Number.isFinite(duration) || duration <= 0) return null
  return Math.max(0, Math.floor(duration - BRANCH_CHOICE_LEAD_SEC))
}
